document.addEventListener("DOMContentLoaded", function () {
  // Set up menu wrapper reference
  const menuWrapper = document.querySelector(".protecta-menu-wrapper");
  const mainMenu = document.querySelector(".protecta-main-menu");
  const secondaryMenu = document.querySelector(".protecta-secondary-menu");
  const menuDivider = document.querySelector(".protecta-menu-divider");
  const allSubmenus = document.querySelectorAll(".protecta-submenu");

  // Ensure all submenus are set up but hidden initially
  allSubmenus.forEach(function (submenu) {
    submenu.classList.remove("active");
  });

  // Make sure main menu is visible initially
  if (mainMenu) {
    mainMenu.classList.remove("slide-out");
    mainMenu.classList.add("slide-in");
  }

  // Reset menu state on page load
  resetMenuToMainState();

  // Staggered animation for menu cards on load
  animateMenuCardsEntrance();

  // Handle submenu navigation with animations
  const hasSubmenuLinks = document.querySelectorAll(".protecta-has-submenu");
  hasSubmenuLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      if (this.getAttribute("href") === "#") {
        e.preventDefault();
        const submenuId = this.getAttribute("data-submenu");
        const submenu = document.getElementById(submenuId);

        if (submenu) {
          // Animate main menu out
          mainMenu.classList.remove("slide-in");
          mainMenu.classList.add("slide-out");

          if (secondaryMenu) {
            secondaryMenu.classList.remove("slide-in");
            secondaryMenu.classList.add("slide-out");
          }

          if (menuDivider) {
            menuDivider.classList.remove("slide-in");
            menuDivider.classList.add("slide-out");
          }

          // Wait for animation to complete before showing submenu
          setTimeout(function () {
            // Ensure all submenus are inactive first
            allSubmenus.forEach(function (menu) {
              menu.classList.remove("active");
            });

            // Show and animate selected submenu
            submenu.classList.add("active");

            // Animate the submenu cards entrance
            animateSubmenuCardsEntrance(submenu);

            // Scroll to top
            window.scrollTo(0, 0);
          }, 200);
        }
      }
    });
  });

  // Handle back button clicks with animations
  const backButtons = document.querySelectorAll(".protecta-back-button");
  backButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Find parent submenu
      const parentSubmenu = this.closest(".protecta-submenu");

      if (parentSubmenu) {
        // Animate submenu out
        parentSubmenu.classList.remove("active");

        // Wait for animation to complete before showing main menu
        setTimeout(function () {
          // Show and animate main menu in
          mainMenu.classList.remove("slide-out");
          mainMenu.classList.add("slide-in");

          if (secondaryMenu) {
            secondaryMenu.classList.remove("slide-out");
            secondaryMenu.classList.add("slide-in");
          }

          if (menuDivider) {
            menuDivider.classList.remove("slide-out");
            menuDivider.classList.add("slide-in");
          }

          // Animate the main menu cards entrance
          animateMenuCardsEntrance();

          // Scroll to top
          window.scrollTo(0, 0);
        }, 200);
      }
    });
  });

  // Add event listener for the menu open/close toggle
  const menuToggle = document.querySelector(".mobile-menu-toggle");
  if (menuToggle) {
    menuToggle.addEventListener("click", function () {
      // Toggle menu animation classes
      if (menuWrapper.classList.contains("hidden")) {
        menuWrapper.classList.remove("hidden");
        menuWrapper.classList.add("entering");

        // Reset to main menu and animate cards
        setTimeout(function () {
          resetMenuToMainState();
          animateMenuCardsEntrance();
        }, 50);
      } else {
        menuWrapper.classList.remove("entering");
        menuWrapper.classList.add("hidden");
      }
    });
  }

  // Function to reset the menu to main state
  function resetMenuToMainState() {
    // Hide all submenus
    allSubmenus.forEach(function (submenu) {
      submenu.classList.remove("active");
    });

    // Show main menu with animation
    mainMenu.classList.remove("slide-out");
    mainMenu.classList.add("slide-in");

    if (secondaryMenu) {
      secondaryMenu.classList.remove("slide-out");
      secondaryMenu.classList.add("slide-in");
    }

    if (menuDivider) {
      menuDivider.classList.remove("slide-out");
      menuDivider.classList.add("slide-in");
    }
  }

  // Animate menu cards with staggered entrance
  function animateMenuCardsEntrance() {
    const cards = mainMenu.querySelectorAll(".protecta-menu-card");
    cards.forEach(function (card, index) {
      // Reset card style first
      card.style.opacity = "0";
      card.style.transform = "translateY(20px)";

      // Animate each card with a delay based on its position
      setTimeout(function () {
        card.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        card.style.opacity = "1";
        card.style.transform = "translateY(0)";
      }, 50 + index * 30); // Staggered delay
    });
  }

  // Animate submenu cards with staggered entrance
  function animateSubmenuCardsEntrance(submenu) {
    const cards = submenu.querySelectorAll(".protecta-menu-card");
    cards.forEach(function (card, index) {
      // Reset card style first
      card.style.opacity = "0";
      card.style.transform = "translateY(20px)";

      // Animate each card with a delay based on its position
      setTimeout(function () {
        card.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        card.style.opacity = "1";
        card.style.transform = "translateY(0)";
      }, 50 + index * 30); // Staggered delay
    });
  }
});
